/* eslint-disable @typescript-eslint/ban-ts-comment */

import moment from 'moment';

// eslint-disable-next-line import/no-cycle
import { padTwo, logError } from 'shared/functions';
import { endTime, zeroTime } from 'shared/constants';

export const localDate = (timestamp: string) => {
  if (timestamp) {
    return moment(`${timestamp}+00:00`);
  }
  return {
    format: () => '',
  };
};

export const momentify = (timestamp: string | Date) => {
  if (!timestamp) {
    return moment();
  } else if (typeof timestamp === 'string') {
    return localDate(timestamp);
  }

  // @ts-expect-error
  if (typeof timestamp === 'object' && timestamp._d) {
    return timestamp;
  }

  logError(`${timestamp} causes momentify error!`);
  // @ts-expect-error
  throw new Error(timestamp);
};

export const secondsToHms = (counter: number, forceHours: boolean) => {
  const preciseDays = counter % 86400;
  const days = Math.floor(counter / 86400).toString();
  const preciseHours = preciseDays % 3600;
  const hours = Math.floor(preciseDays / 3600).toString();
  const minutes = Math.floor(preciseHours / 60).toString();
  const seconds = Math.floor(preciseHours % 60).toString();
  return `${days !== '0' ? `${days}d ` : ''}${hours === '0' && !forceHours ? '' : `${padTwo(hours)}:`}${padTwo(
    minutes,
  )}:${padTwo(seconds)}`;
};

export const durationToDhm = (duration: string) => {
  const counter = parseInt(duration, 0);
  const preciseDays = counter % 86400;
  const days = Math.floor(counter / 86400).toString();
  const preciseHours = preciseDays % 3600;
  const hours = Math.floor(preciseDays / 3600).toString();
  const minutes = Math.floor(preciseHours / 60).toString();
  return days === '0' ? `${hours === '0' ? '' : `${hours} h `}${minutes} min` : '>24 h';
};

export const getYearsOptions = (before = 90, after = 0) => {
  const yearsOptions = [];
  const currentYear = moment().year();
  for (let shift = 0; shift < before; shift++) {
    const yearToAdd = `${currentYear - shift}`;
    yearsOptions.unshift({
      value: yearToAdd,
      label: yearToAdd,
    });
  }
  for (let shift = 1; shift <= after; shift++) {
    const yearToAdd = `${currentYear + shift}`;
    yearsOptions.push({
      value: yearToAdd,
      label: yearToAdd,
    });
  }
  return yearsOptions;
};

export const endifyTime = (time: string) => (time === zeroTime ? endTime : time);
